/** Dev/simulated device verification — production would use SMS/voice OTP provider. */

export const BF001_MASKED_PHONE = "(***) ***-1234";
export const BF001_DEV_OTP = "123456";

export function maskPhoneForDisplay(phoneLast4: string): string {
  return `(***) ***-${phoneLast4}`;
}

export function validateDeviceOtp(code: string, expected = BF001_DEV_OTP): boolean {
  const normalized = code.replace(/\D/g, "");
  return normalized === expected;
}
